<template>
    <nav class="navbar navbar-black">
        <div class="container">
            <div class="collapse navbar-collapse">
                <ul class="nav navbar-nav">
                    <sub-menu-link 
                            v-for="link in displayedLinks"
                            :key="link.id"
                            :id="link.id"
                            :url="link.url" 
                            :text="link.text"
                            :links="link.links"
                            :active="active"
                    ></sub-menu-link>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import SubMenuLink from '@/components/Layout/SubMenu/SubMenuLink'
    
    export default {
        components: {SubMenuLink},
        
        props: ['links', 'active'],

        computed: {
            displayedLinks() {
                return this.links.filter(link => typeof link.display === 'undefined' || link.display)
            }
        }
    }
</script>
